export default __webpack_public_path__ + "static/media/gaisano@2x.17bc316a.png";